import React from "react";
import { Button } from "@material-ui/core";
import { Link, useRouteMatch } from "react-router-dom";
import { useAccountGate } from "../AccountGate";

export const WrapUpNotesButton: React.FC = () => {
  const { url } = useRouteMatch();
  const { status, isAccessible } = useAccountGate();

  return isAccessible && status !== "loading" ? (
    /* Only shows on "orphaned" accounts and once loading is finished */
    <Button
      component={Link}
      to={url + "/notes"}
      disableElevation
      variant="contained"
      color="primary"
      size="large"
    >
      Wrap-up notes
    </Button>
  ) : null;
};
